import { Injectable } from '@angular/core';
import { Bac, ChildBac, RootBac } from '@app/library/models/bac.model';
import { Playlist } from '@app/library/models/playlist.model';

@Injectable({
  providedIn: 'root',
})
export class LibraryBacHelperService {
  /**
   * Check if the bac is currently selected according to the url
   */
  isBacActive(url: string, bac: Bac): boolean {
    if (!bac) {
      return false;
    }
    const urlStriped = url.split('?')[0];
    const urlBac = `/media/${bac.url}`;

    return urlStriped.endsWith(urlBac);
  }

  isTrashActive(url: string): boolean {
    const urlStriped = url.split('?')[0];
    const urlTrash = '/media/trash';

    return urlStriped.endsWith(urlTrash);
  }

  isPlaylistActive(url: string, playlist: Playlist): boolean {
    if (!playlist) {
      return false;
    }
    const urlStriped = url.split('?')[0];
    const urlPlaylist = `/media/playlist/${playlist.id}`;

    return urlStriped.endsWith(urlPlaylist);
  }

  /**
   * Check if the given url can be found
   * in one of the given parent's children
   */
  isUrlInChildren(parent: Bac | RootBac | ChildBac, url: string): boolean {
    if (!parent.children) {
      return false;
    }

    for (const child of parent.children) {
      if (this.isBacActive(url, child)) {
        return true;
      }

      if (child.children) {
        if (this.isUrlInChildren(child, url)) {
          return true;
        }
      }
    }

    return false;
  }
}
